import { useEffect, useState } from 'react';
import { Button } from 'shared/ui/Button';
import { SideModal, SideModalBody, useModals, useModalsActions } from 'shared/ui/SideModal';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import { Integration } from './Integration';
import { EditEmailsModal } from './EditEmailsModal';
import { useTestLeads } from './hooks';

export interface ManageEmailsModalProps {
  skipPrevModal?: boolean;
  campaignId: number;
  emails: string[];
}

export function ManageEmailsModal({ emails, campaignId, skipPrevModal }: ManageEmailsModalProps) {
  const { removeModalByIndex } = useModalsActions();
  const [emailsList, setEmailsList] = useState(emails);
  const { open } = useModalsActions();
  const modals = useModals();
  const { openTestLead, openedTestLeads, closeTestLead, clearAllLeads } = useTestLeads();

  useEffect(() => {
    if (skipPrevModal) {
      // TODO: this is the crutch for prev modal removing, need API for it
      setTimeout(() => removeModalByIndex(modals.length - 2), 400);
    }
  }, []);

  return (
    <SideModal autoTestAttributesName="email-notification-modal">
      <SideModalBody title="Email notifications">
        <div className="mb-4 text-sm">You can add more emails and then manage them from this screen.</div>
        <Button
          className="w-full"
          variant="outline"
          size="big"
          {...getDataAutoTestAttributes(['button-manage-email-address'])}
          onClick={() => {
            clearAllLeads();
            open(
              <EditEmailsModal
                campaignId={campaignId}
                emails={emailsList}
                onUpdated={setEmailsList}
              />
            );
          }}
        >
          Manage email address
        </Button>
        <div className="my-8 border-t border-slate-100" />
        {emailsList.map((email, index) => (
          <Integration
            index={index}
            key={email}
            campaignId={campaignId}
            isOpenedTestLead={openedTestLeads[email]}
            openTestLead={openTestLead}
            closeTestLead={closeTestLead}
            value={{
              id: index,
              isActive: false,
              label: email,
            }}
            disableActivationSwitcher
            isEmail
          />
        ))}
      </SideModalBody>
    </SideModal>
  );
}
